import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import SearchIcon from '@assets/images/icons/search.svg'
import { useDispatch, useSelector } from 'react-redux'
import { toggleSearchOverlay } from '@/redux/ducks/menu/main'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // eslint plugin doesn't recognize animations used in other styles
  // eslint-disable-next-line
  '@keyframes borderSlideIn': {
    from: { transform: 'translate3d(100%, 0, 0)' },
    to: { transform: 'translate3d(0, 0, 0)' },
  },
  searchIcon: {
    position: 'relative',
    '& path': {
      fill: 'var(--color-menu-icon)',
    },
    '&:hover path': {
      fill: theme.primary,
    },
  },
  active: ({
    fill: theme.primary,
    '&:after': {
      content: '""',
      width: 0,
      height: 0,
      borderTop: '10px solid transparent',
      borderBottom: '10px solid transparent',
      borderRight: `10px solid ${theme.backgroundColor}`,
      animationName: '$borderSlideIn',
      animationDuration: '0.5s',
      animationFillMode: 'forwards',
      position: 'absolute',
      right: 0,
      [theme.devices.mobile]: {
        top: 19,
        borderTop: '10px solid transparent',
        borderBottom: `10px solid ${theme.backgroundColor}`,
        borderRight: '10px solid transparent',
        borderLeft: '10px solid transparent',
      },
    },
    '& $searchIcon path': {
      fill: theme.primary,
    },
  }),
  hideActiveIcon: {
    '&:after': {
      display: 'none',
    },
  },
  iconWrapper: {
    position: 'relative',
  },
  [theme.devices.mobile]: {
    container: {
      flexDirection: 'row',
      margin: 0,
      width: 'auto',
    },
    iconWrapper: {
      marginRight: 30,
    },
    searchIcon: {
      height: 20,
    },
  },
}))

interface SearchButtonProps {
  hideActiveIcon?: boolean,
  iconSize?: { width: number, height: number },
  styles?: { root: string },
}

const SearchButton = (props: SearchButtonProps) => {
  const dispatch = useDispatch()
  const {
    iconSize = { width: 20, height: 20 },
    hideActiveIcon,
    styles = { root: '' },
  } = props
  const classes = useStyles()
  const searchOverlayOpen = useSelector(state => state.menu.main.searchOverlayOpen)

  const className = clsx(
    classes.container,
    classes.iconWrapper,
    styles.root,
    searchOverlayOpen && classes.active,
    hideActiveIcon && classes.hideActiveIcon,
  )

  return (
    <a
      className={className}
      data-qs-id='search-menu-button'
      onClick={() => dispatch(toggleSearchOverlay(!searchOverlayOpen))} >
      <span className={classes.searchIcon}>
        <SVGIcon
          width={`${iconSize.width}px`}
          height={`${iconSize.height}px`}
          svg={SearchIcon}
        />
      </span>
    </a>
  )
}

export default SearchButton
